import React, { useState, useEffect } from 'react';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { useAuth } from '../../context/authContext';

const LockIconWrapper = ({ right, children, iconSize = 'small', ...props }) => {
  const { checkRightOnlyInExpanded, checkRightAny } = useAuth();
  const [needsLockIcon, setNeedsLockIcon] = useState(false);

  // Check rights only once when component mounts
  useEffect(() => {
    const hasRight = checkRightAny(right);
    const onlyInExpanded = checkRightOnlyInExpanded(right);
    const shouldShowLock = hasRight && onlyInExpanded;
    setNeedsLockIcon(shouldShowLock);
  }, []);

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }} {...props}>
      {children}
      {needsLockIcon && <LockOpenIcon fontSize={iconSize} />}
    </span>
  );
};

export default LockIconWrapper;
